import createReducer from './../lib/createReducer';
import * as types from './../actions/types';

export const preferences = createReducer({
  isPreferenceSaved: null,
  details: null,
  intents:null,
  classes:null,
  isSchemaFetched:false,
  schema:{}
}, {
  [types.GET_PREFERENCES_START](state) {
    const newState = Object.assign({}, state, {
      isPreferenceSaved: null,
      details: null,
      isFetchingPreferences: true,
    });

    return newState;
  },
  [types.GET_PREFERENCES_SUCCESS](state, action) {
    const newState = Object.assign({}, state, {
      details: action.preferences,
      paymentTypes: action.paymentTypes,
      insurances: action.insurances,
      amenities: action.amenities,
      recipients: action.recipients,
      isFetchingPreferences: false,
    });

    return newState;
  },
  [types.GET_PREFERENCES_FAIL](state) {
    const newState = Object.assign({}, state, {
      details: {},
      isFetchingPreferences: false,
    });

    return newState;
  },
  [types.SET_PREFERENCES_START](state) {
    const newState = Object.assign({}, state, {
      isPreferenceSaved: null,
      isPreferencesaving:true,
    });

    return newState;
  },
  [types.SET_PREFERENCES_SUCCESS](state, action) {
    const newState = Object.assign({}, state, {
      isPreferenceSaved: true,
      details: action.preferences,
      isPreferencesaving:false
    });

    return newState;
  },
  [types.SET_PREFERENCES_FAIL](state) {
    const newState = Object.assign({}, state, {
      isPreferenceSaved: false,
      isPreferencesaving:false
    });

    return newState;
  },
  [types.GET_GROUP_INTENT_START](state) {
    const newState = Object.assign({}, state, {
      getGroupIntent: true,
    });

    return newState;
  },
  [types.GET_GROUP_INTENT_SUCCESS](state,action) {
    const newState = Object.assign({}, state, {
      getGroupIntent: false,
      intents: action.intents
    });

    return newState;
  },
  [types.GET_GROUP_INTENT_FAIL](state) {
    const newState = Object.assign({}, state, {
      getGroupIntent: false,
    });

    return newState;
  },
  [types.GET_FREE_PRICING_PLANS](state,action) {
      const newState = Object.assign({}, state, {
        classes: action.response,
      });

      return newState;
    },
    [types.GET_PREFERENCE_SCHEMA_START](state) {
      const newState = Object.assign({}, state, {
        isSchemaFetched: false,
      });

      return newState;
    },
    [types.GET_PREFERENCE_SCHEMA_FAIL](state) {
      
      const newState = Object.assign({}, state, {
        isSchemaFetched: false,
      });

      return newState;
    },
    [types.GET_PREFERENCE_SCHEMA_SUCCESS](state,action) {
      console.log('Schema',action);
      const newState = Object.assign({}, state, {
        isSchemaFetched: true,
        schema: action.preferences.properties
      });

      return newState;
    },
});

export { preferences as default };
